<button mat-button fxLayout="row" fxLayoutAlign="center" *ngIf="loading">

    <div fxLayoutAlign="space-evenly center">
        <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
        <p>Processando, aguarde...</p>
    </div>
</button>
<form [formGroup]="itemOsForm" fxLayout="column" autocomplete="off" *ngIf="!loading">


    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px"
        fxLayoutAlign="end center">

        <mat-form-field class="mr-12" style="padding-top: 8px;" fxFlex="10" *ngIf="this.orderItem?.id">
            <mat-label>Desconto </mat-label>
            <input matInput name="discount" currencyMask [formControl]="discountControl"
                [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 2}" />
            <button *ngIf="type == '1'" mat-icon-button matPrefix [disabled]="disableDeleteOrderPay"
                matTooltip="Mudar para percentual" mat-icon-button (click)="changeType('2')">
                R$
            </button>
            <button *ngIf="type == '2'" mat-icon-button matPrefix [disabled]="disableDeleteOrderPay"
                matTooltip="Mudar para Dinheiro" mat-icon-button (click)="changeType('1')">
                %
            </button>
            <button mat-icon-button (click)="applyDiscount()" matSuffix [disabled]="disableDeleteOrderPay"
                matTooltip="Aplicar desconto">
                <mat-icon>check</mat-icon>
            </button>
        </mat-form-field>

        <button matTooltip="Voltar" id="back" *ngIf="!progress" mat-stroked-button class="mr-12 order-button"
            (click)="action('back')">Voltar
            <mat-icon>reply</mat-icon>
        </button>

        <button matTooltip="Novo" id="new" color="primary" *ngIf="!progress" mat-stroked-button
            class="mr-12 order-button" (click)="action('new')" [disabled]="!checkStatus()"> Novo
            <span class="material-icons">add</span>
        </button>

        <button matTooltip="Cancelar Alteração" [disabled]="!orderItem.id" *ngIf="!progress" id="cancel" color="warn"
            mat-stroked-button class="mr-12 order-button" (click)="action('cancel')">
            Cancelar Alteração
            <span class="material-icons">cancel</span>
        </button>

        <button matTooltip="Salvar" color="accent" *ngIf="!progress" [disabled]="progress" mat-stroked-button
            class="mr-12 order-button" (click)="submitForm()">Salvar
            <span class="material-icons">backup</span>
        </button>

        <div fxLayout="row" fxLayoutAlign="space-evenly center" *ngIf="progress">
            <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
            <p>{{actionString}}...</p>
        </div>

    </div>
    <mat-divider class="mb-15"></mat-divider> <br>
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fxFlex="100">

        <mat-form-field appearance="outline" class="mr-8" fxFlex="30" *ngIf="isProcedure">
            <mat-label>Profissional</mat-label>
            <input matInput name="professional" [matAutocomplete]="autoProfessional" formControlName="professional"
                autocomplete="off" type="search" required />
            <mat-autocomplete autoActiveFirstOption #autoProfessional="matAutocomplete" autoActiveFirstOption
                (optionSelected)="getSpeciality($event.option.value)" [displayWith]="displayPerformerFn">
                <mat-option *ngFor="let performer of performerList" [value]="performer">
                    <p *ngIf="performer">
                        {{ performer.professional.person.name }}
                    </p>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="mr-8" *ngIf="isProcedure">
            <mat-label>Especialidade</mat-label>
            <input matInput name="speciality" [matAutocomplete]="autoSpeciality" formControlName="speciality"
                autocomplete="off" type="search" required />
            <mat-autocomplete autoActiveFirstOption #autoSpeciality="matAutocomplete" autoActiveFirstOption
                [displayWith]="displaySimpleFn">
                <mat-option *ngFor="let speciality of specialistyList" [value]="speciality">
                    <p *ngIf="speciality">
                        {{ speciality.name }}
                    </p>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="mr-8" fxFlex="15">
            <mat-label>Data</mat-label>
            <input autocomplete="off" matInput [matDatepicker]="dateItemOs" placeholder="Data"
                formControlName="dateItemOs" required />
            <mat-datepicker-toggle id="dateInitPicker" matSuffix [for]="dateItemOs"></mat-datepicker-toggle>
            <mat-datepicker #dateItemOs></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="10" class="mr-8 ">
            <mat-label>Horário</mat-label>
            <input matInput name="hour" required formControlName="hour" type="time" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="10" class="mr-8">
            <mat-label>Horário final</mat-label>
            <input matInput name="hour" required formControlName="hourend" type="time" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="!isProcedure">
            <mat-label>Quantidade</mat-label>
            <input matInput name="quantity" required formControlName="quantity" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="!isProcedure">
            <mat-label>Valor</mat-label>
            <input matInput name="procedureValue" required formControlName="procedureValue" currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}" />
        </mat-form-field>

    </div>
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fxFlex="100">
        <!-- <mat-form-field appearance="outline" class="mr-8">
            <mat-label>Tipo de Lançamento</mat-label>
            <mat-select matInput (selectionChange)="changeTypeItem($event)" value="1">
                <mat-option value="1" selected>Procedimento</mat-option>
                <mat-option value="2">Material</mat-option>
                <mat-option value="3">Medicamento</mat-option>
                <mat-option value="4">Outros Produtos</mat-option>
            </mat-select>
        </mat-form-field> -->

        <!-- matTooltip="{{ this.itemOsForm.controls.description.value ? this.itemOsForm.controls.description.value.name : ''}}" -->
        <mat-form-field appearance="outline" fxFlex="50" class="mr-8">
            <mat-label>Item</mat-label>
            <input matInput name="description" [matAutocomplete]="autoProcedureItem" formControlName="description"
                autocomplete="off" type="search" required />
            <mat-error *ngIf="itemOsForm.get('description').hasError('incorrect')">
                Serviço inválido
            </mat-error>
            <button *ngIf="this.itemOsForm.controls.description.value" [disabled]="!checkStatus()" matSuffix
                mat-icon-button aria-label="Clear" (click)="this.itemOsForm.controls.description.setValue('')">
                <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autoProcedureItem="matAutocomplete" autoActiveFirstOption
                [displayWith]="displaySimpleFn" (optionSelected)="
                    handleProcedureSelected($event.option.value.id, $event.option.value.accreditationId)
                ">
                <mat-option *ngFor="let procedure of procedureList" [value]="procedure" style="height: auto;">
                    <div class="space">
                        <p>{{ procedure.name }}</p>
                        <p>Código: {{procedure.code }} </p>
                    </div>

                    <mat-divider></mat-divider>

                </mat-option>
            </mat-autocomplete>

        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="10" class="mr-8">
            <mat-label>Código</mat-label>
            <input matInput name="procedureCode" required formControlName="procedureCode" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="isProcedure">
            <mat-label>Quantidade</mat-label>
            <input matInput name="quantity" required formControlName="quantity" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="isProcedure">
            <mat-label>Valor unitário</mat-label>
            <input matInput name="procedureValue" required formControlName="procedureValue" currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="orderItem.id">
            <mat-label>Valor Total</mat-label>
            <input matInput name="total" formControlName="total" readonly currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}" />
        </mat-form-field>


        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="isProcedure">
            <mat-label>Desconto</mat-label>
            <input matInput name="discount" required formControlName="discount" currencyMask
                [options]="{ prefix: ' ', thousands: '.', decimal: ',', precision: 2}" />
            <p matPrefix mat-icon-button disabled>
                R$
            </p>
        </mat-form-field>



    </div>

    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fxFlex="80">



        <mat-form-field appearance="outline" class="w-20-p mr-8" *ngIf="isProcedure">
            <mat-label>Profissonal Solicitante</mat-label>

            <input matInput name="profissionalRequest" formControlName="profissionalRequest"
                [matAutocomplete]="autoProfissionalRequest" autocomplete="off" type="search" />

            <button matSuffix mat-icon-button aria-label="Clear" title="Cadastro de Solicitante"
                (click)="registrationSolic()">
                <mat-icon>add</mat-icon>
            </button>

            <mat-autocomplete autoActiveFirstOption #autoProfissionalRequest="matAutocomplete" autoActiveFirstOption
                [displayWith]="displayPerformerFn" (optionSelected)="setSolic($event.option.value)">
                <mat-option *ngFor="let professional of profissionalList" [value]="professional" style="height: auto;">
                    <div class="space">
                        <p>{{ professional.person.name }}</p>
                        <p>N. Conselho: {{ professional.councilNumber }} </p>
                        <p>Tipo: {{ professional.staff ? 'Interno' : 'Externo' }} </p>
                    </div>

                    <mat-divider></mat-divider>

                </mat-option>
            </mat-autocomplete>

        </mat-form-field>


        <mat-form-field appearance="outline" fxFlex="7">
            <mat-label>UF</mat-label>
            <input matInput name="UF" readonly
                [value]="itemOsForm.controls['profissionalRequest']?.value?.state?.initials" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8">
            <mat-label>Número do Conselho</mat-label>
            <input matInput name="numeroConselho" readonly
                [value]="itemOsForm.controls['profissionalRequest']?.value?.councilNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="8" class="mr-8" *ngIf="isProcedure">
            <mat-label>Tipo do solicitante</mat-label>
            <input matInput name="tipoSolicitante" formControlName="tipoSolicitante" readonly
                [value]="tipoSolicitante" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="20" class="mr-8">
            <mat-label>Empresa Solicitante</mat-label>

            <input matInput name="autoFirmRequest" formControlName="firm" [matAutocomplete]="autoFirmRequest"
                autocomplete="off" type="search" />
            <button *ngIf="itemOsForm.controls['firm'].value" matSuffix mat-icon-button aria-label="Clear"
                (click)="itemOsForm.controls['firm'].setValue(null)">
                <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autoFirmRequest="matAutocomplete" autoActiveFirstOption
                [displayWith]="displayFirmFn">

                <mat-option *ngFor="let firm of firmList" [value]="firm" style="height: auto !important;">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        {{ firm.name }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <span><b>Inscrição:</b> {{ firm.registry }}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-15-p mr-8" *ngIf="isProcedure">
            <mat-label>Profissional Credenciado</mat-label>
            <input matInput name="credentiatedProfessional" [matAutocomplete]="autoPerformerCredentiatedProfessional"
                formControlName="credentiatedProfessional" autocomplete="off" type="search" />
            <mat-autocomplete autoActiveFirstOption #autoPerformerCredentiatedProfessional="matAutocomplete"
                autoActiveFirstOption [displayWith]="displayPerformerFn">
                <mat-option *ngFor="let performer of performeAccreditationList" [value]="performer">
                    <p *ngIf="performer">
                        {{ performer.professional.person.name }}
                    </p>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-15-p mr-8" *ngIf="isProcedure">
            <mat-label>Anestesista</mat-label>
            <input matInput [matAutocomplete]="autoPerformerAnesthetist" autocomplete="off" type="search"
                formControlName="professionalAnesthetist" />
            <mat-autocomplete autoActiveFirstOption #autoPerformerAnesthetist="matAutocomplete" autoActiveFirstOption
                [displayWith]="displayPerformerFn">
                <mat-option *ngFor="let performer of performerList" [value]="performer">
                    <p *ngIf="performer">
                        {{ performer.professional.person.name }}
                    </p>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

    </div>
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px" fxFlex="80">
        <mat-form-field appearance="outline" class="mr-12" fxFlex="8">
            <mat-label>Lançado por: </mat-label>
            <input matInput [formControl]="userCreatedControl" readonly="readonly">
        </mat-form-field>
        <mat-form-field appearance="outline" class="mr-12" fxFlex="8">
            <mat-label>Atualizado por: </mat-label>
            <input matInput [formControl]="userUpdatedControl" readonly="readonly">
        </mat-form-field>

    </div>
    <div fxLayout="column" class="mb-10">
        <h3 *ngIf="sessionView">Informações de sessão</h3>
        <div *ngIf="sessionView" fxLayout="row" fxFlex="100">
            <cw-sessionLaunch fxFlex="100" [iOrder]="order" [iserviceFrequencyPerWeek]="serviceFrequencyPerWeek"
                [iProcedure]="itemOsForm.controls['description'].value?.id"
                [iQuantSessionCurrent]="itemOsForm.controls['quantity'].value"
                [iServiceDate]="itemOsForm.controls['dateItemOs'].value" [iContext]="'ORDER_ITEM'"
                (oSession)="getSession($event)"></cw-sessionLaunch>
        </div>
    </div>
    <!-- *ngIf="sessionView"  -->
    <!-- <div fxLayout="row" class="mb-10">
        <div fxLayout="row" fxFlex="100">
            <cw-sessionLaunch fxFlex="100" [iOrder]="order"
                [iQuantSessionCurrent]="itemOsForm.controls['quantity'].value"
                [iServiceDate]="itemOsForm.controls['dateItemOs'].value"
                (oSession)="getSession($event)"></cw-sessionLaunch>
        </div>
    </div> -->
    <br>

    <div>
        <h1>Dados adicionais</h1>
        <mat-list class="pt-16 pb-0">
            <form name="phoneForm" [formGroup]="dadosAdicionaisForm" class="contact-edit" autocomplete="off">
                <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px"
                    class="w-100-p">

                    <mat-form-field appearance="outline" class="mr-12" fxFlex="10">
                        <mat-label>Via de Acesso</mat-label>
                        <mat-select matInput formControlName="viaAccess" [compareWith]="compareSelect">
                            <mat-option [value]="null">Selecione</mat-option>
                            <mat-option *ngFor="let via of viaAccess" [value]="via">{{via.code}} |
                                {{via.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mr-12" fxFlex="20">
                        <mat-label>Via da Administração</mat-label>
                        <mat-select matInput formControlName="viaAdministration" [compareWith]="compareSelect">
                            <mat-option *ngFor="let via of viaAdministration" [value]="via"> {{via.code}} | {{via.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mr-12" fxFlex="10">
                        <mat-label>Técnica</mat-label>
                        <mat-select matInput formControlName="technique">
                            <mat-option [value]="null">Selecione
                            </mat-option>
                            <mat-option [value]="'1'"> 1 | Convencional
                            </mat-option>
                            <mat-option [value]="'2'">2 | Video
                            </mat-option>
                            <mat-option [value]="'3'">3 | Robótica
                            </mat-option>
                        </mat-select>
                    </mat-form-field>


                    <mat-form-field appearance="outline" class="mr-8" fxFlex="8">
                        <mat-label>Token do Atendimento</mat-label>
                        <input matInput name="token" formControlName="token" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="25" class="mr-12">
                        <mat-label>Grau de Participação</mat-label>
                        <mat-select id="operational-reception-order_item_tiss-degreeParticipation-edit-form_cs"
                            [compareWith]="compareSelect" name="degreeParticipation"
                            formControlName="degreeParticipation">
                            <mat-option [value]="null">
                                Selecione
                            </mat-option>
                            <mat-option *ngFor="let degreeParticipation of degreeParticipationList"
                                [value]="degreeParticipation">
                                {{ degreeParticipation.code}} | {{degreeParticipation.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mr-8" fxFlex="8">
                        <mat-label>Fator red. acréscimo</mat-label>
                        <input matInput name="reductionAddition" formControlName="reductionAddition" readonly />
                    </mat-form-field>


                </div>

                <div fxLayout="row" class="w-100-p" fxLayoutGap="10">
                    <label id="example-radio-group-label">Local: </label>
                    <mat-radio-group formControlName="location" aria-label="local" class="style-radio">
                        <mat-radio-button value="N">Normal</mat-radio-button>
                        <mat-radio-button value="A">Ap.Simples</mat-radio-button>
                        <mat-radio-button value="E">Enfermaria</mat-radio-button>
                        <mat-radio-button value="S">Suíte</mat-radio-button>
                    </mat-radio-group>

                </div>
                <div fxLayout="row" class="w-100-p">
                    <p><mat-checkbox formControlName="nightShift">Adicional Noturno</mat-checkbox></p>

                </div>


            </form>
            <br />
        </mat-list>
    </div>
    <br />

    <div fxLayout="row">
        <ng-container *ngIf="showAttendanceMaterial">
            <cwg-attendance-material #attendanceMaterialOrder [iOrder]="order" fxFlex="100"
                (oFeeKitList)="setKitList($event, 'F')" (oDrugKitList)="setKitList($event,'D')"
                (oMaterialKitList)="setKitList($event,'M')" (oAuxiliaryKitList)="setKitList($event, 'A')"
                (oOpmeKitList)="setKitList($event, 'O')">
            </cwg-attendance-material>
        </ng-container>

    </div>

</form>
<br />